@if (is_admin && shopping_cart) {
  <ts-admin-override-banner
    [admin_override]="admin_override.value"
    (emit_admin_override)="getAdminOverride($event)"
  />
}

<div class="container-md p-md-0" [tds-data-loader]="{ key: 'devices-list', global: true }">
  <div class="row g-3">
    <div class="col col-12">
      <ts-asset-selection
        header="{{ 'my_devices' | translate }}"
        no_asset_text="{{ 'no_associated_devices' | translate }}"
        [asset_fields]="['imei', 'imei2', 'eid', 'serial_number', 'sim_compatibility']"
        [existing_asset]="existing_asset"
        (asset_selection_emit)="selectAssetClick($event, 1, false)"
        (assets_response_emit)="getUserAssets($event)"
      />
    </div>

    <div class="col col-12">
      <div class="card shadow-sm">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <h4 class="mb-3">{{ 'add_new_device' | translate }}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <form role="search" [formGroup]="search_form" (ngSubmit)="searchDevices()">
                <label class="form-label" for="DeviceIdentifierSearch">
                  {{ 'device_identifier' | translate }}
                </label>
                <a
                  class="ms-1 d-inline-block cursor-pointer"
                  (click)="openDeviceIdentifierInfoModal($event)"
                >
                  <span class="material-icons rounded-circle device-identifier-help themed-icon">
                    question_mark
                  </span>
                </a>
                <div class="input-group">
                  <input
                    id="DeviceIdentifierSearch"
                    class="form-control"
                    type="search"
                    placeholder="{{ 'device_identifier_placeholder' | translate }}"
                    formControlName="device_identifier"
                  />
                  <button type="submit" class="btn form-element-btn">
                    {{ 'search' | translate }}
                  </button>
                </div>
              </form>
              @if (show_search_results) {
                <div id="DeviceIdentifierSearchResults" class="row row-cols-1 mt-3">
                  <div class="col">
                    @if (!!search_result) {
                      <div
                        class="row row-cols-1"
                        [tds-data-loader]="{ key: 'lookup-device', as_overlay: true }"
                      >
                        <div class="col d-flex flex-column gap-3" role="listbox">
                          @for (asset of search_result; track asset) {
                            <div
                              class="card position-relative overflow-hidden elevate-white asset-card"
                              role="option"
                              [attr.aria-label]="assetAriaLabel(asset)"
                              (click)="selectAssetClick(asset, 2, false)"
                            >
                              @if (asset.line && asset.line?.is_primary_contact) {
                                <div
                                  class="position-absolute top-0 start-0 asset-card__primary"
                                  aria-label="Primary line"
                                >
                                  <span class="material-icons">verified</span>
                                </div>
                              }
                              @if (
                                isSelectedAsset(asset) && existing_asset?.asset_selection_case === 2
                              ) {
                                <div
                                  [ngClass]="{
                                    'position-absolute top-0 start-100 text-end': true,
                                    'currently-in-cart': device_id_matches
                                  }"
                                >
                                  <span
                                    ngbTooltip="{{ 'selected_item' | translate }}"
                                    class="material-icons"
                                  >
                                    check_circle
                                  </span>
                                </div>
                              }
                              <div class="card-body card-items card-items-md asset-card__details">
                                <ts-asset-selection-item
                                  [asset]="asset"
                                  [asset_fields]="[
                                    'imei',
                                    'imei2',
                                    'eid',
                                    'serial_number',
                                    'sim_compatibility'
                                  ]"
                                />
                              </div>
                              @if (hasMultiSim(asset)) {
                                <div stop-click-propagation class="card-footer">
                                  <button
                                    type="button"
                                    class="d-flex justify-content-center btn text-capitalize fw-normal w-100"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#multiSimOffCanvas"
                                    aria-controls="multiSimOffCanvas"
                                    (click)="openAssetOffCanvas(multiSimOffCanvas, asset)"
                                  >
                                    @if (asset.multi_sim_type === multi_sim_types[0]) {
                                      <span>
                                        <span class="material-icons lh-base">hub</span>&nbsp;
                                        <span>
                                          {{ 'additional_lines' | translate }}
                                          ({{ asset.additional_lines?.length }})
                                        </span>
                                      </span>
                                    }
                                    @if (
                                      [multi_sim_types[1], multi_sim_types[6]].includes(
                                        asset.multi_sim_type
                                      )
                                    ) {
                                      <span>
                                        <span class="material-icons lh-base">hub</span>&nbsp;
                                        <span>
                                          {{ 'additional_devices' | translate }}
                                          ({{ asset.additional_devices?.length }})
                                        </span>
                                      </span>
                                    }
                                  </button>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    } @else {
                      <div id="DeviceCreationForm" class="row">
                        <div
                          class="col"
                          [tds-data-loader]="{ key: 'lookup-device', as_overlay: true }"
                        >
                          <ngb-alert
                            class="show"
                            role="alert"
                            [type]="'info'"
                            [dismissible]="false"
                          >
                            <span>{{ 'device_not_in_inventory' | translate }}</span>
                          </ngb-alert>
                          <ts-device-creation-form
                            [existing_asset]="existing_asset"
                            [device_identifier_search_value]="
                              search_form.controls['device_identifier'].value
                            "
                            [shopping_cart]="shopping_cart"
                            [admin_override]="admin_override"
                            (cancel_override_toggle)="cancelAdminOverrideToggle($event)"
                          />
                        </div>
                      </div>
                    }
                  </div>
                </div>
              } @else {
                <div
                  class="row"
                  [tds-data-loader]="{ key: 'lookup-device', size: 'md', class: 'col mt-3' }"
                ></div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<span [tds-data-loader]="{ key: 'asset-details', global: true }"></span>

<ng-template #noAssets>
  <div id="DeviceCreationForm" class="row">
    <div class="col" [tds-data-loader]="{ key: 'lookup-device', as_overlay: true }">
      <ngb-alert class="show" role="alert" [type]="'info'" [dismissible]="false">
        <span>{{ 'device_not_in_inventory' | translate }}</span>
      </ngb-alert>
      <ts-device-creation-form
        [existing_asset]="existing_asset"
        [device_identifier_search_value]="search_form.controls['device_identifier'].value"
        [shopping_cart]="shopping_cart"
        [admin_override]="admin_override"
        (cancel_override_toggle)="cancelAdminOverrideToggle($event)"
      />
    </div>
  </div>
</ng-template>

<ng-template #noSearch>
  <div
    class="row"
    [tds-data-loader]="{ key: 'lookup-device', size: 'md', class: 'col mt-3' }"
  ></div>
</ng-template>

<ng-template #deviceIdentifierInfo let-modal>
  <div class="modal-header">
    <h4 class="modal-title lh-sm mt-1">
      {{ 'locate_device_identifier' | translate }}
    </h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body pt-0 mt-1">
    <div class="row">
      <div class="col">
        <p class="lh-1">
          {{ 'locate_device_identifier_hint' | translate }}
        </p>
        <span
          id="DeviceIdentifierHelpText"
          [innerHTML]="device_identifier_help_text | domSanitizer"
        ></span>
        <small class="d-inline-block mt-3">
          {{ 'locate_device_identifier_footnote' | translate }}
        </small>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #blockFlowModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h4 class="modal-title">{{ modal_header }}</h4>
    <button
      class="btn-close m-0"
      type="button"
      aria-label="Close"
      (click)="dismissModal()"
    ></button>
  </div>

  <div class="modal-body pt-0">
    <div class="row">
      <div class="col">
        <span class="fw-light">{{ modal_body }}</span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col d-flex justify-content-end">
        <button class="btn btn-primary px-5" type="button" (click)="dismissModal()">
          {{ ('ok' | translate).toUpperCase() }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- 1DML Modal -->
<ng-template #multiSimDeviceModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'multisim_add_replace_line' | translate }}
    </h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.close('Cross Click')"
    ></button>
  </div>
  <div class="modal-body pt-0" name="1DML-modal-body">
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light" [innerHTML]="multisimModalBody(multi_sim_modal_asset?.asset)"></span>
      </div>
    </div>
    <ul class="list-group multisim-lines-modal-list">
      <li
        class="list-group-item list-group-item-action cursor-pointer"
        [ngClass]="{
          active:
            shopping_cart?.add_additional_line && deviceInCart(multi_sim_modal_asset?.asset?.device)
        }"
        (click)="selectMultiSimLine(multi_sim_modal_asset?.asset?.line!, true)"
      >
        {{ 'multisim_add_additional_line' | translate }}
      </li>
      @if (
        (multi_sim_modal_asset?.asset &&
          [multi_sim_types[0], multi_sim_types[2], multi_sim_types[5]].includes(
            multi_sim_modal_asset?.asset!.multi_sim_type
          ) &&
          multi_sim_modal_asset?.asset?.line) ||
        (from_chained_multi_sim_device && multi_sim_modal_asset?.asset?.line)
      ) {
        <li
          class="d-flex list-group-item list-group-item-action cursor-pointer"
          [ngClass]="{
            active:
              lineInCart(
                from_chained_multi_sim_device
                  ? multi_sim_modal_asset!.chained_multi_sim_asset?.line!
                  : multi_sim_modal_asset!.asset.line
              ) &&
              multi_sim_modal_asset?.asset?.multi_sim_type ===
                shopping_cart.existing_asset?.multi_sim_type &&
              multi_sim_modal_asset?.selection_case ===
                shopping_cart.existing_asset?.asset_selection_case &&
              !shopping_cart?.add_additional_line
          }"
          (click)="
            selectMultiSimLine(
              from_chained_multi_sim_device
                ? multi_sim_modal_asset?.chained_multi_sim_asset?.line!
                : multi_sim_modal_asset?.asset?.line!
            )
          "
        >
          {{ 'multisim_replace_line' | translate }}
          {{
            from_chained_multi_sim_device
              ? multi_sim_modal_asset?.chained_multi_sim_asset?.line?.international_number
              : multi_sim_modal_asset?.asset?.line?.international_number
          }}
          ({{
            from_chained_multi_sim_device
              ? multi_sim_modal_asset?.chained_multi_sim_asset?.line?.carrier_name
              : multi_sim_modal_asset?.asset?.line?.carrier_name
          }})
          @if (
            (multi_sim_modal_asset?.asset &&
              multi_sim_modal_asset?.asset?.multi_sim_type === multi_sim_types[0]) ||
            from_chained_multi_sim_device
          ) {
            <span
              class="d-inline-block material-icons fs-inherit ms-1"
              [ngClass]="
                !lineInCart(
                  from_chained_multi_sim_device
                    ? multi_sim_modal_asset?.chained_multi_sim_asset?.line!
                    : multi_sim_modal_asset?.asset?.line!
                ) ||
                multi_sim_modal_asset?.selection_case !==
                  shopping_cart.existing_asset?.asset_selection_case ||
                shopping_cart?.add_additional_line
                  ? 'text-info'
                  : ''
              "
            >
              verified
            </span>
          }
        </li>
      }
      @for (
        additional_line of calculateModalAdditionalLines(
          from_chained_multi_sim_device
            ? multi_sim_modal_asset?.chained_multi_sim_asset
            : multi_sim_modal_asset?.asset
        );
        track additional_line
      ) {
        <li
          class="list-group-item list-group-item-action cursor-pointer"
          [ngClass]="{
            active:
              lineInCart(additional_line) &&
              multi_sim_modal_asset?.asset?.multi_sim_type ===
                shopping_cart.existing_asset?.multi_sim_type &&
              multi_sim_modal_asset?.selection_case ===
                shopping_cart.existing_asset?.asset_selection_case &&
              !shopping_cart?.add_additional_line
          }"
          (click)="selectMultiSimLine(additional_line)"
        >
          {{ 'multisim_replace_line' | translate }} {{ additional_line.international_number }} ({{
            additional_line.carrier_name
          }})
        </li>
      }
    </ul>
  </div>
</ng-template>

<!-- 1LMD Modal -->
<ng-template #multiSimLineModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'multisim_line' | translate }}
    </h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.close('Cross Click')"
    ></button>
  </div>
  <div class="modal-body pt-0" name="1DML-modal-body">
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light" [innerHTML]="multisimModalBody(multi_sim_modal_asset?.asset)"></span>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <span class="fw-light" [innerHTML]="multisimModalPrompt(multi_sim_modal_asset?.asset)">
        </span>
      </div>
    </div>
    <ul class="list-group multisim-devices-modal-list">
      @if (
        multi_sim_modal_asset?.asset &&
        [multi_sim_types[1], multi_sim_types[6]].includes(
          multi_sim_modal_asset!.asset.multi_sim_type
        ) &&
        hasDeviceId(
          from_chained_multi_sim_device
            ? multi_sim_modal_asset?.chained_multi_sim_asset?.device!
            : multi_sim_modal_asset?.asset?.device!
        )
      ) {
        <li
          class="d-flex list-group-item list-group-item-action cursor-pointer"
          [ngClass]="{
            active:
              deviceInCart(multi_sim_modal_asset!.asset.device) &&
              multi_sim_modal_asset?.asset?.multi_sim_type ===
                shopping_cart.existing_asset?.multi_sim_type &&
              multi_sim_modal_asset?.selection_case ===
                shopping_cart.existing_asset?.asset_selection_case
          }"
          (click)="
            selectAssetClick(
              multi_sim_modal_asset!.asset.device,
              multi_sim_modal_asset?.selection_case || 1,
              true
            )
          "
        >
          {{ constructAssetTitle(multi_sim_modal_asset?.asset, true) }}
          <span
            class="d-inline-block material-icons fs-inherit ms-1"
            [ngClass]="
              !deviceInCart(multi_sim_modal_asset?.asset?.device!) ||
              multi_sim_modal_asset?.selection_case !==
                shopping_cart.existing_asset?.asset_selection_case
                ? 'text-info'
                : ''
            "
          >
            verified
          </span>
        </li>
      }
      @for (
        additional_device of calculateModalAdditionalDevices(multi_sim_modal_asset?.asset);
        track additional_device
      ) {
        <li
          class="list-group-item list-group-item-action cursor-pointer"
          [ngClass]="{
            active:
              deviceInCart(additional_device) &&
              multi_sim_modal_asset?.asset?.multi_sim_type ===
                shopping_cart.existing_asset?.multi_sim_type &&
              multi_sim_modal_asset?.selection_case ===
                shopping_cart.existing_asset?.asset_selection_case
          }"
          (click)="
            selectAssetClick(
              additional_device,
              this.multi_sim_modal_asset?.selection_case ?? 1,
              true
            )
          "
        >
          {{ constructAdditionalAssetTitle(additional_device, 1) }}
        </li>
      }
    </ul>
  </div>
</ng-template>

<ng-template #multiSimOffCanvas let-offcanvas>
  <ts-multisim-offcanvas
    class="overflow-auto"
    [offcanvas_asset]="offcanvas_asset"
    [offcanvas]="offcanvas"
  ></ts-multisim-offcanvas>
</ng-template>
